<script setup>
import {reactive, ref} from 'vue'
import {State, getModels, go} from '@/paks/vu-app'
import {uploadZip} from '@/paks/vu-dash'
import Zip from 'jszip'

//  TODO
const MaxZip = 5 * 1024 * 1024

const props = defineProps({})

const emit = defineEmits(['input'])

const page = reactive({
    files: null,
    import: null,
})

//  Component refs
const primary = ref(null)
const confirm = ref(null)

async function save(validate) {
    let {files} = page
    page.saving = true
    if (files) {
        const {Manager} = getModels()
        let zip = new Zip()
        let list = await zip.loadAsync(files)
        let manager = await Manager.get({id: State.app.app.id})
        await uploadZip(manager, list)
    }
    await confirm.value.ask('Please wait a minute for the assets to be deployed', {disagree: false})
    page.saving = false
    validate.clear()
    go({name: 'pages'})
}

function cancel() {
    go({name: 'pages'})
}
</script>

<template>
    <vu-form class="page app-assets" help="/doc/ui/view/app-assets.html" ref="primary" :data="page" :save="save">
        <div class="vrow">
            <vu-sign name="designer-assets" title="Upload App Assets" color="accent">
                <p>App assets, such as logos, icons, stylesheets and more, can be used to fully customize the app. The assets are copied to the App's cloud CDN and can update existing app files. Assets under the directory <b>./theme</b> can be preserved when the app is updated if the preserve assets option is checked in the Builder.  </p>
            </vu-sign>
        </div>
        <vu-input
            v-model="page.files"
            accept="text/zip"
            class="file-input mb-4"
            density="compact"
            hide-details="auto"
            label="Upload App Assets"
            placeholder="ZIP file"
            name="zip"
            show-size
            type="file"
            :clearable="true"
            :multiple="false" />

        <div class="actions mb-0">
            <v-btn :disabled="!page.files" size="small" color="primary" type="submit" :loading="page.saving">Deploy</v-btn>
            <v-btn size="small" color="none" @click="cancel">Cancel</v-btn>
        </div>
        <vu-confirm ref="confirm" />
    </vu-form>
</template>

<style lang="scss">
.app-assets {
    margin-top: 20px;
    margin-bottom: 0 !important;
    .vu-sign {
        width: 100%;
    }
    .v-select-list {
        padding: 0;
        border: solid 1px rgb(var(--v-theme-border-lighten-1));
        border-radius: 0;
    }
    h3 {
        font-weight: normal;
        color: rgb(var(--v-theme-text));
    }
    .page-form {
        max-width: 800px !important;
    }
    .display-control {
        label {
            font-size: 1.2rem;
            font-weight: bold;
            margin-bottom: 8px;
        }
    }
}
</style>
